// Configuration runtime interface
export interface RuntimeConfig {
  LXC_FI_DEVICE_VERSION: string;
  LXC_AS_DEVICE_URL: string;
}

const defaultConfig: RuntimeConfig = {
  LXC_FI_DEVICE_VERSION: "local-version",
  LXC_AS_DEVICE_URL: "http://localhost:3333/lxc-as-web",
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__: Partial<RuntimeConfig>;
  }
}

function val(str: string | undefined, fallback: string): string {
  return typeof str === "string" && str.length > 0 ? str : fallback;
}

export function getRuntimeConfig(): RuntimeConfig {
  const w = typeof window !== "undefined" ? window : ({} as never);
  const runtimeConfig = (w.__RUNTIME_CONFIG__ || {}) as Partial<RuntimeConfig>;
  const env = import.meta.env || {};

  return {
    LXC_FI_DEVICE_VERSION: val(
      runtimeConfig.LXC_FI_DEVICE_VERSION || env.LXC_FI_DEVICE_VERSION,
      defaultConfig.LXC_FI_DEVICE_VERSION,
    ),
    LXC_AS_DEVICE_URL: val(
      runtimeConfig.LXC_AS_DEVICE_URL || env.LXC_AS_DEVICE_URL,
      defaultConfig.LXC_AS_DEVICE_URL,
    ),
  };
}
